<!--
 * @Author: zyy
 * @Date: 2023-03-14 14:36:08
 * @LastEditors: zyy
 * @LastEditTime: 2023-03-15 10:40:40
 * @Description: default
-->
<template>
    <div>
        <div class="flex container-box">
            <div style="flex:2">
                <a-card style="border-radius: 20px;">
                    <div class="text-right" style="margin-bottom: 50px;">
                        <a-select placeholder="请选择时间" style="width: 180px;" v-model="fastTime" @change="handelFastTime">
                            <a-select-option :value="0" :key="1">今日</a-select-option>
                            <a-select-option :value="1" :key="1">昨日</a-select-option>
                            <a-select-option :value="2" :key="2">近一周</a-select-option>
                            <a-select-option :value="3" :key="3">近一月</a-select-option>
                            <a-select-option :value="4" :key="4">近一年</a-select-option>
                        </a-select>
                        <a-range-picker format="YYYY-MM-DD HH:mm:ss" class="ml-2" style="width:400px" :show-time="true"
                            @ok="getStatisticsInfo" v-model="form.datetimerange" valueFormat="YYYY-MM-DD HH:mm:ss" />

                    </div>
                    <div class="charts-box">
                        <div id="main" style="width: 100%;height:400px;"></div>

                    </div>
                </a-card>
            </div>
            <div class="cardlist-box">
                <a-card hoverable :bordered="false" class="card-box color-blue" @click="handelCurrent('payOrderArr')">
                    <div class="flex items-center">
                        <img src="../../../../assets/images/avatar.png">
                        <div class="ml-2">
                            <div>支付订单</div>
                            <div>单位/笔</div>
                        </div>
                    </div>
                    <div class="mt-2 text-center text-3xl">{{ info.payOrderNum }}</div>
                </a-card>

                <a-card hoverable :bordered="false" class="card-box color-darkblue" @click="handelCurrent('payAmountArr')">
                    <div class="flex items-center">
                        <img src="../../../../assets/images/avatar.png">
                        <div class="ml-2">
                            <div>支付金额</div>
                            <div>单位/元</div>
                        </div>
                    </div>
                    <div class="mt-2 text-center text-3xl font-bold">{{ info.payAmountNum }}</div>
                </a-card>

                <a-card hoverable :bordered="false" class="card-box color-green" @click="handelCurrent('noSentArr')">
                    <div class="flex items-center">
                        <img src="../../../../assets/images/avatar.png">
                        <div class="ml-2">
                            <div>代发货订单</div>
                            <div>单位/笔</div>
                        </div>
                    </div>
                    <div class="mt-2 text-center text-3xl font-bold">{{ info.noSentNum }}</div>
                </a-card>

                <a-card hoverable :bordered="false" class="card-box color-purple" @click="handelCurrent('orderArr')">
                    <div class="flex items-center">
                        <img src="../../../../assets/images/avatar.png">
                        <div class="ml-2">
                            <div>支付人数（累计）</div>
                            <div>单位/人</div>
                        </div>
                    </div>
                    <div class="mt-2 text-center text-3xl font-bold">{{ info.orderNum }}</div>
                </a-card>

                <a-card hoverable :bordered="false" class="card-box color-orange">
                    <div class="flex items-center">
                        <img src="../../../../assets/images/avatar.png">
                        <div class="ml-2">
                            <div>好评数</div>
                            <div>单位/笔</div>
                        </div>
                    </div>
                    <div class="mt-2 text-center text-3xl font-bold">{{ info.commentAmount }}</div>
                </a-card>

                <a-card hoverable :bordered="false" class="card-box color-red">
                    <div class="flex items-center">
                        <img src="../../../../assets/images/avatar.png">
                        <div class="ml-2">
                            <div>好评率</div>
                            <div>单位/%</div>
                        </div>
                    </div>
                    <div class="mt-2 text-center text-3xl font-bold">{{ info.commentRate * 100 }}%</div>
                </a-card>

            </div>
        </div>

        <a-card class="container-box">
            <div class="flex items-center justify-between mb-2">
                <div>TOP5</div>
                <a-select v-model="form.categoryId" placeholder="请选择分类" style="width: 220px;" @change="getStatisticsInfo">
                    <a-select-option :value="item.id" v-for="item in categoryList" :key="item.id">{{ item.name
                    }}</a-select-option>
                </a-select>
            </div>

            <a-table :columns="columns" :data-source="table.data" rowKey="id" :pagination="false">
                <span slot="image" slot-scope="image">
                    <dy-image :src="image" preview style="width:40px;height:40px"></dy-image>
                </span>
            </a-table>
        </a-card>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import StatisticsService from '@/io/goods/statistics.js'
import GoodsTypeService from "@/io/goods_type.js";
import { $dateFormat } from '@/plugins/utils.js'



export default {
    data() {
        return {
            currentChartName: 'payOrderArr',
            fastTime: 0,
            chartEle: undefined,
            info: {},
            form: {
                datetimerange: [
                    $dateFormat('YYYY-MM-DD HH:mm:ss', new Date(new Date().setHours(0, 0, 0, 0))),
                    $dateFormat('YYYY-MM-DD HH:mm:ss', new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1))
                ],
                categoryId: undefined
            },
            search: {
                category: undefined
            },
            columns: [
                {
                    title: "排名",
                    dataIndex: "id",
                    key: "id",
                },
                {
                    title: "商品图",
                    dataIndex: "image",
                    key: "image",
                    scopedSlots: { customRender: "image" },
                },
                {
                    title: "商品名称",
                    dataIndex: "title",
                    key: "title",
                },
                {
                    title: "商品销量",
                    dataIndex: "sales",
                    key: "sales",
                },
                {
                    title: "销售额（元）",
                    dataIndex: "sale_total_money",
                    key: "sale_total_money",
                },
            ],
            categoryList: [],
            table: {
                data: []
            },
            charts: {
                xData: [],
                yData: [],
                max: 10
            }
        }
    },
    computed: {
        chartOpts() {
            return {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        label: {
                            backgroundColor: "#6a7985",
                        },
                    },
                },
                xAxis: {
                    type: 'category',
                    data: this.charts.xData
                },
                yAxis: {
                    type: 'value',
                    max: this.charts.max,
                    min: 0
                },
                series: [
                    {
                        data: this.charts.yData,
                        type: 'line',
                        smooth: true,
                        //   拐点
                        itemStyle: {
                            opacity: 0,
                        },
                        lineStyle: {
                            color: "#56bae2",
                        },
                        areaStyle: {
                            color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: "#56bae2", // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: "#fff", // 100% 处的颜色
                                    },
                                ],
                                global: false, // 缺省为 false
                            },
                        },

                    }
                ]
            }
        }
    },
    async mounted() {
        this.chartEle = echarts.init(document.getElementById('main'));
        await this.getCategoryList()
        this.getStatisticsInfo()
    },
    methods: {
        // 快速选择时间
        handelFastTime(data) {
            const day = 24 * 60 * 60 * 1000

            switch (data) {
                case 0:
                    this.form.datetimerange = [
                        this.getFormatTimeStr(),
                        this.getFormatTimeStr(day-1)]
                    break
                case 1:
                    this.form.datetimerange = [
                    this.getFormatTimeStr(-day),
                    this.getFormatTimeStr(-1)]
                    break
                case 2:
                    this.form.datetimerange = [
                    this.getFormatTimeStr(-day*7),
                    this.getFormatTimeStr(day-1)
                    ]
                    break
                case 3:
                    this.form.datetimerange = [
                    this.getPreMonth(),
                    this.getFormatTimeStr(day-1)]
                    break
                case 4:
                    this.form.datetimerange = [
                    this.getFormatTimeStr(-day*365),
                        this.getFormatTimeStr(day-1)]
                    break
                default:
                    break;
            }
        },
        /**
         * @description: 获取对应日期
         * @param {*} time:单位：秒
         * @return {*}
         */        
        getFormatTimeStr(time=0){
            return $dateFormat('YYYY-MM-DD HH:mm:ss', new Date(new Date().setHours(0, 0, 0, 0) + time))
        },
        handelCurrent(name = "payOrderArr") {
            this.currentChartName = name
            this.getStatisticsInfo()

        },
        // 更新echarts
        updateCharts() {
            this.chartEle.setOption(this.chartOpts);
        },
        // 获取数据
        getStatisticsInfo() {
            let timeData = this.form.datetimerange.join(' - ')
            StatisticsService.statistics({
                categoryId: this.form.categoryId,
                datetimerange: timeData
            }).then(res => {
                this.table.data = res.data.goodsList
                this.info = res.data
                this.charts.xData = this.getChartData(this.info[this.currentChartName]).xData
                this.charts.Ydata = this.getChartData(this.info[this.currentChartName]).yData
                this.chartOpts.series[0].data = this.getChartData(this.info[this.currentChartName]).yData
                this.charts.max = this.calMax(this.charts.Ydata)
                this.updateCharts()

            })
        },
        // 获取分类
        async getCategoryList() {
            await GoodsTypeService.list(1, 100).then(res => {
                this.categoryList = res.data.rows
                this.form.categoryId = res.data.rows[0].id

            })
        },
        // 处理数据，获取xyData
        getChartData(data) {
            let xData = []
            let yData = []
            xData = data.map(val => val.createtime)
            yData = data.map(val => val.counter)
            return {
                xData,
                yData
            }
        },
        // 取最大值
        calMax(arr) {
            let spaceNum = 5
            //计算最大值
            let maxA = Math.max(...arr); // 最大值A
            let maxint = Math.ceil(maxA / spaceNum); //最大平均值（向上取整）= 最大值A / 间隔数
            let maxB = maxint * spaceNum; // 最大值B = 最大平均值 * 间隔数  （注：最大值B>最大值A）
            return Math.max(maxB, 10); // 为了防止maxB数据为0时，Y轴不显示，给个默认最大值10
        },

        // 获取上一个月时间
        getPreMonth() {
            let date = $dateFormat('YYYY-MM-DD HH:mm:ss',new Date(new Date().setHours(0, 0, 0, 0)))
            let arr = date.split('-');
            let year = arr[0]; //获取当前日期的年份
            let month = arr[1]; //获取当前日期的月份
            let day = arr[2]; //获取当前日期的日
            let days = new Date(year, month, 0);
            days = days.getDate(); //获取当前日期中月的天数
            let year2 = year;
            let month2 = parseInt(month) - 1;
            if (month2 == 0) {//如果是1月份，则取上一年的12月份
                year2 = parseInt(year2) - 1;
                month2 = 12;
            }
            let day2 = day;
            let days2 = new Date(year2, month2, 0);
            days2 = days2.getDate();
            if (day2 > days2) {//如果原来日期大于上一月的日期，则取当月的最大日期。比如3月的30日，在2月中没有30
                day2 = days2;
            }
            if (month2 < 10) {
                month2 = '0' + month2;//月份填补成2位。
            }
            var t2 = year2 + '-' + month2 + '-' + day2;
            return t2;
        }
    }
}

</script>

<style scoped lang='less'>
.cardlist-box {
    display: flex;
    // flex-direction: column;
    flex-wrap: wrap;
    flex: 1;
    margin-left: 20px;

    .card-box {
        // width: calc((100%-16px)/2);
        margin-bottom: 16px;
        width: 48%;
        border-radius: 20px;

    }

    .card-box:nth-child(2n+1) {
        margin-right: 16px;
    }

    img {
        width: 60px;
        height: 60px;
        border-radius: 20px;
    }
}

.charts-box {}

.container-box {
    margin: 20px;
    border-radius: 20px;
}

.color-blue {
    color: #2f98c9;
}
.color-darkblue {
    color: #2a68ba;
}
.color-green {
    color: #2abab3;
}
.color-purple {
    color: #8c61bd;
}
.color-orange {
    color: #ff6a00;
}
.color-red {
    color: #fb8387;
}


</style>